import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbOffcanvas, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PdfService } from '../../../../core/services/pdf.service';
import { ProfessorAcademicClassroomService } from '../../../../core/services/professor-academic-classroom.service';
import { StudentAyClassroomService } from '../../../../core/services/student-ay-classroom.service';
import { StudentService } from '../../../../core/services/student.service';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../../admin/layout/includes/header/header.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { StudentListComponent } from '../../../components/student-list/student-list.component';

@Component({
    selector: 'app-classroom-students-list',
    templateUrl: './classroom-students-list.component.html',
    imports: [
        StudentListComponent,
        CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxExtendedPdfViewerModule
    ],
    styleUrls: ['./classroom-students-list.component.css']
})
export class ClassroomStudentsListComponent {
  
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined
  vue="list"
  buttonsPermission :any|undefined;
 search_text=""
  classrooms:any[] =[]
  roles:any[] =[]
  data:any[] =[]
  selected_data:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  tag="professors-claasroom-students-list"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any
  classroomId:any
  pdfViewLoader=false


  constructor(
    private studentService:StudentService,
    private pdfService:PdfService,
    private spinnerService:NgxSpinnerService,
    private sacService:StudentAyClassroomService,
    private pacService:ProfessorAcademicClassroomService,
    private toastrService:ToastrService,
    private offcanvasService: NgbOffcanvas,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
this.getActions()
  }

  init(){
    this.professorAcademicClassroomList()
  
  }

 

  getStudentAcademicClassroomList(classroomId:any){
    this.spinnerService.show()
    this.sacService.getAll(classroomId).subscribe((res:any)=>{
      this.data=res.data
      this.pg.pageSize=10
      this.pg.p=0
      this.pg.total=res.data.length
      this.modalService.dismissAll()
      this.spinnerService.hide()

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des classes apprenants",err)
    })
  }
  professorAcademicClassroomList(){
    this.pacService.getProfessorAcademicClassrooms().subscribe((res:any)=>{
      this.classrooms=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des classes apprenants",err)
    })
  }

  loadlist(e:any){
    this.classroomId=e.target.value
    this.getStudentAcademicClassroomList(e.target.value)
  }


  store(value:any){
    this.loading=true
    
    this.sacService.store(value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des classes apprenants",err)

    })
  }
  update(value:any){
    this.loading=true

    this.studentService.update(this.selected_data.student.id,{
      birthdate:value.birthdate
    }).subscribe((res:any)=>{
      this.loading=false
      this.getStudentAcademicClassroomList(this.classroomId)

        this.toastrService.success(res.message)
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des classes apprenants",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.sacService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des classes apprenants",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(ev:any,content:any){
    this.selected_data=ev
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.sacService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Gestion des classes apprenants",err)

      })
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:false,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }



  changeView(event:any){
    this.vue=event.target.value
  }

  getPdf(){
    var students:any[]=[];
    this.loading=true
    this.data.forEach((el:any)=> students.push(el.student?.current_ay_classroom?.id));
    this.pdfService.getClassroomStudentsList({
      students:students,
      classroomId:this.classroomId
    }).subscribe((res:any)=>{
      console.log(res);

      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel', position: 'end'  });
      this.loading=false

  },
  (err:any)=>{
    console.log(err)
    this.loading=false

      AppErrorShow.showError("Gestion des cours",err)

  })
  }
}
